import React from 'react';
import penguinSandClock from 'assets/icons/penguin-sand-clock.svg';
import { ModalComponent } from '../modal/modalComponent';
import { ProgressBar } from '../../componentsV2/ProgressBar/ProgressBar';
import { formatText } from 'core/i18n';
import { isMobile } from 'utilities/browser';

import './ModalLoader.scss';

const ModalLoader = ({ open, onClose }) => {
    const subtitleText = isMobile()
        ? formatText('signingPage-modalLoaderSubtitleMobile')
        : formatText('signingPage-modalLoaderSubtitle');

    return (
        <ModalComponent isOpen={open} onCancel={onClose} className="modal-loader">
            <div className="modal-loader__container">
                <img src={penguinSandClock} alt="loader-icon" />

                <ProgressBar className="modal-loader__progressbar" />

                <h3 className="modal-loader__title">{formatText('signingPage-modalLoaderTitle')}</h3>
                <h4 className="modal-loader__subtitle">{subtitleText}</h4>
            </div>
        </ModalComponent>
    );
};

export default ModalLoader;
